var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12H22.05V13.95C22.05 15.8795 21.2835 17.7299 19.9192 19.0942C18.5549 20.4585 16.7045 21.225 14.775 21.225H8.77501C6.84556 21.225 4.99513 20.4585 3.6308 19.0942C2.26647 17.7299 1.5 15.8795 1.5 13.95V12Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17505 3.22501H2.47502C3.84752 3.22501 5.16379 3.77023 6.13429 4.74073C7.10479 5.71123 7.65004 7.02751 7.65004 8.4H7.35002C5.97753 8.4 4.66125 7.85478 3.69075 6.88428C2.72025 5.91378 2.17505 4.5975 2.17505 3.22501Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 4.65001C9.87202 3.98106 10.2233 3.37552 10.7434 2.93752C11.2636 2.49951 11.92 2.2564 12.6 2.25C13.3698 2.26902 14.1028 2.58331 14.6472 3.12778C15.1917 3.67226 15.506 4.40525 15.525 5.17502C15.5118 5.48001 15.4614 5.78223 15.375 6.075L16.275 5.92502C17.0448 5.94403 17.7777 6.2583 18.3222 6.80278C18.8667 7.34726 19.181 8.08024 19.2 8.85001",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.225 9.07501C14.4293 9.07501 13.6663 8.75894 13.1037 8.19633C12.541 7.63373 12.225 6.87066 12.225 6.07501",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDish);
export default __webpack_public_path__ + "static/media/dish.edc10f86f8afd228a837e497e026a9c3.svg";
export { ForwardRef as ReactComponent };